import { Microscope } from "lucide-react";
import { defineModuleUi } from "@vixio/data";
import { lazyPage } from "@vixio/ui";
import "./api";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const StudiesPage = lazyPage(() => import("./StudiesPage"), "StudiesPage");
const StudyPage = lazyPage(() => import("./StudyPage"), "StudyPage");

export default defineModuleUi({
  key: "research",
  title: "Estudos científicos",
  domain: "diagnostics",
  icon: Microscope,
  menu: [{ path: "/diagnostico/estudos", label: "Estudos científicos", minRole: "member", icon: Microscope, order: 60, keywords: "cep caae parecer tcle chancela inpes validação participantes anonimizada" }],
  routes: [
    { path: "/diagnostico/estudos", element: <StudiesPage />, minRole: "member" },
    { path: "/diagnostico/estudos/:id", element: <StudyPage />, minRole: "member" },
  ],
});
